import ajax from "@/utils/ajax.js";

export default {
  async getGroundComboboxItemsAsync(input) {
    const response = await ajax.post("scenic/GetGroundComboboxItemsAsync", input);
    return response.result;
  },
  async getGroundChangCiComboboxItemsAsync(input) {
    const response = await ajax.post(
      "/scenic/GetGroundChangCiComboboxItemsAsync",
      input
    );
    return response.result;
  },
  async getGroundChangCiItemsAsync(input) {
    const response = await ajax.post(
      "/scenic/GetGroundChangCiItemsAsync",
      input
    );
    return response.result;
  },
  async getGroundChangCiItemsForBehalfAsync(input) {
    const response = await ajax.post(
      "/scenic/GetGroundChangCiItemsForBehalfAsync",
      input
    );
    return response.result;
  },  
  async validExceedWxLastBookTime(){
    const response = await ajax.get("/scenic/ValidExceedWxLastBookTime");
    return response.result;
  },
  async getGroundDtosAsync(input){
    const response = await ajax.post("scenic/GetGroundDtosAsync", input);
    return response.result;
  },
  async getNewsThemesAsync() {
    const response = await ajax.get("/scenic/GetNewsThemesAsync");
    return response.result;
  },
  async getNewsAsync(id) {
    const response = await ajax.get(`/scenic/GetNewsAsync?id=${id}`);
    return response.result;
  },
};
